import type { UnrepresentableValue } from '@castoredc/castor_prose';

export const isUnrepresentableValue = (
  value: unknown
): value is UnrepresentableValue =>
  typeof value === 'object' &&
  value !== null &&
  'rawData' in value &&
  typeof value.rawData === 'string';
